import { normalize, schema } from 'normalizr';
import { IState, ActionTypes } from './type';

const userGoalsSchema = new schema.Entity('usergoals');
const userGoalListSchema = [userGoalsSchema];

const initial: IState = {
  entities: {},
  ids: [],
  count: 0,
  loading: false,
  error: null
};
const reducer = (state: IState = initial, action: any) => {
  switch (action.type) {
    case ActionTypes.REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      };

    case ActionTypes.SUCCESS: {
      const normalizedData = normalize(action.payload.results, userGoalListSchema);

      return {
        ...state,
        entities: {
          ...state.entities,
          ...normalizedData.entities.usergoals,
        },
        ids: normalizedData.result as string[],
        count: action.payload.count as number,
        loading: false
      };
    }

    case ActionTypes.SUCCESS_SINGLE: {
      const userGoal = action.payload;
    
      return {
        ...state,
        entities: {
          ...state.entities,
          [userGoal.id]: userGoal
        },
        loading: false
      };
    }

    case ActionTypes.CREATE_SUCCESS: {
      const userGoal = action.payload;
    
      return {
        ...state,
        entities: {
          ...state.entities,
          [userGoal.id]: userGoal
        },
        loading: false
      };
    }

    case ActionTypes.UPDATE_SUCCESS: {
      const userGoal = action.payload;
    
      return {
        ...state,
        entities: {
          ...state.entities,
          [userGoal.id]: userGoal
        },
        loading: false
      };
    }

    case ActionTypes.DELETE_SUCCESS: {
      const { id } = action.payload;
    
      const { [id]: deletedItem, ...remainingEntities } = state.entities;
    
      return {
        ...state,
        entities: remainingEntities,
        ids: state.ids.filter(existingId => existingId !== id),
        loading: false
      };
    }

    case ActionTypes.FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload
      };
    default:
      return state;
  }
}

export default reducer;
